export const getUserData = state => state.user.get('userData');
export const getUserAccount = state => state.user.get('userAccount');
export const getUserValidationError = state => state.user.get('validationError');
export const getAllAccountsLoadedInfo = state => state.user.get('allAccountsLoaded');
export const validationError = state => state.migrate.get('validationError');
export const selectDepartments = state => state.user.get('departments');
export const billableDepartments = state => state.user.get('billableDepartments');
export const departmentNumbers = state => state.user.get('departments').map(item => item.customerNumber);
export const orderDeadlines = state => state.user.get('orderDeadlines');
export const deepLinkInfoLoading = state => state.user.get('deepLinkInfoLoading');
export const accountDetails = state => state.user.get('accountDetails');
export const alwaysShowCart = state => state.user.get('alwaysShowCart');
export const getOrderShippingAddress = state => state.orders.get('orderShippingAddress');
